// import axios from "axios";
// import { GENERATE_FLASHCARDS_FAILURE, GENERATE_FLASHCARDS_SUCCESS } from "./flashcards.actionTypes";
// import { POST_GENERATE_FLASHCARDS } from "../../utils/api";

// export const generateCards = (payLoad) => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   try {
//     const resp = await axios.post(POST_GENERATE_FLASHCARDS, payLoad, {
//       headers,
//       withCredentials: true,
//     });

//     if (resp.data) {
//       const succcess = resp?.data;
//       dispatch({
//         type: GENERATE_FLASHCARDS_SUCCESS,
//         payload: resp.data 
//       });
//       return succcess;
//     } else {
//       dispatch({
//         type: GENERATE_FLASHCARDS_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: GENERATE_FLASHCARDS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };.

import { apiRequest } from "../../api/apiRequest";
import { GENERATE_FLASHCARDS_FAILURE, GENERATE_FLASHCARDS_SUCCESS } from "./flashcards.actionTypes";
import { POST_GENERATE_FLASHCARDS } from "../../utils/api";

export const generateCards = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_GENERATE_FLASHCARDS, payLoad);

  if (result.success) {
    dispatch({
      type: GENERATE_FLASHCARDS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: GENERATE_FLASHCARDS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
  return result;
};

